import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState
} from 'react'
import { ThemeProvider } from '@mui/material'

import { darkTheme } from '../../styles/theme/v5/darkTheme'
import { lightTheme } from '../../styles/theme/v5/lightTheme'

import useMediaQuery from '@mui/material/useMediaQuery'

export interface ThemeContextProps {
  themeName: string
  toggleTheme: () => void
}

interface ThemeProviderProps {
  children: ReactNode
  temaUsuario?: 'light' | 'dark'
}

const ThemeContext = createContext({} as ThemeContextProps)

const AppThemeProvider = ({ children }: ThemeProviderProps) => {
  const [themeName, setThemeName] = useState<'light' | 'dark'>('light')

  const toggleTheme = useCallback(() => {
    setThemeName(oldTheme => (oldTheme === 'light' ? 'dark' : 'light'))
  }, [])

  const theme = useMemo(() => {
    return themeName === 'light' ? lightTheme : darkTheme
  }, [themeName])

  return (
    <ThemeContext.Provider value={{ themeName, toggleTheme }}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  )
}

const useTheme = () => {
  const context = useContext(ThemeContext)

  return context
}

export { AppThemeProvider, useTheme, useMediaQuery }
